const a = "26.1.0", s = {
  version: a
}, i = (t) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${s.version}/images/avatar-status/images/images/${t}.png`, e = (t) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${s.version}/images/content/images/images/${t}.svg`, m = (t) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${s.version}/images/identity/images/images/${t}.svg`, c = (t) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${s.version}/images/payment-method/images/images/${t}.svg`, g = (t) => `https://static.cdnaffs.com/my/static/libs/affstore-ui-kit/v${s.version}/images/social/images/images/${t}.svg`;
export {
  i as getAvatarStatusImagePath,
  e as getContentImagePath,
  m as getIdentityImagePath,
  c as getPaymentMethodImagePath,
  g as getSocialImagePath
};
//# sourceMappingURL=affstore-ds-images.js.map
